import { render, staticRenderFns } from "./fileDataMoon.vue?vue&type=template&id=613d3afe&scoped=true&"
import script from "./fileDataMoon.vue?vue&type=script&lang=js&"
export * from "./fileDataMoon.vue?vue&type=script&lang=js&"
import style0 from "./fileDataMoon.vue?vue&type=style&index=0&id=613d3afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613d3afe",
  null
  
)

export default component.exports